import ProductMdl from '@/models/Warehouse/WhProduct'
const fetchProduct = async function (productId){
    try{
        let product = await ProductMdl.include('wh_item','wh_tags', 'wh_subfamily').append('sale_prices').find(productId)
        return product
    }
    catch(error){
        return error.response.data
    }
}

const fetchProductPurchaseOrders = async function (productId){
    try{
        //let product = await ProductMdl.include('wh_item','wh_tags').append('sale_prices').find(productId)
        let product = await ProductMdl.custom('bypass=true')
        .append('purchase_orders')
        .find(productId)
        return product
    }
    catch(error){
        return error.response.data
    }
}

export default {
    fetchProduct
}